<template>
  <!-- 战团管理-积分商品 -->
  <div class="integra_goods-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item style="margin-right: 30px">
          <el-switch
            v-model="shop_status"
            :active-value="1"
            :inactive-value="0"
            active-text="打开积分商城"
            inactive-text="关闭积分商城"
            @change="setShopStatus"
          ></el-switch>
        </el-form-item>
        <el-form-item label="定时开启时间段:">
          <!-- <el-time-picker
            v-model="formData.start_time"
            format="HH"
            value-format="HH"
            placeholder="开始时间"
          >
          </el-time-picker> -->
          <el-time-picker
            v-model="formData.start_time"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            value-format="HH:mm:ss"
            placeholder="开始时间"
            style="width: 150px"
          >
          </el-time-picker>
          ——
          <el-time-picker
            v-model="formData.end_time"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59',
            }"
            value-format="HH:mm:ss"
            placeholder="结束时间"
            style="width: 150px"
          >
          </el-time-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog">新增物品</el-button>
        </el-form-item>
        <el-form-item style="margin-right: 30px">
          <el-input v-model="query.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">搜索</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="商品id" align="center">
        </el-table-column>
        <el-table-column prop="display_name" label="商品名称" align="center">
        </el-table-column>
        <el-table-column label="商品图片" align="center">
          <template slot-scope="{ row }">
            <img width="80" :src="row.img" alt="" />
          </template>
        </el-table-column>
        <el-table-column prop="point" label="积分" align="center">
        </el-table-column>
        <!-- <el-table-column prop="display_name" label="商品名称" align="center">
          <template slot-scope="{ row }">
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- <EditIntegralGoods
      :visible="dialogVisible"
      v-model="dialogInfos"
      @close="dialogVisible = false"
      @refresh="getData"
    ></EditIntegralGoods> -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
// import EditIntegralGoods from '@/components/battle_groups/EditIntegralGoods.vue'

export default {
  components: {
    // EditIntegralGoods
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      shop_status: false,//商城状态开关,0是关闭，1是打开
      loading: false,//加载动画
      formData: {
        start_time: '',
        end_time: ''
      },
      query: {
        page: 1,
        name: ''
      },
      dialogType: undefined,//弹窗类型
      dialogInfos: undefined,//弹窗数据
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getShopStatus() {
      //获取商城开关状态
      getApiData('')
        .then(res => {
          if (res) {
            res.data ? this.shop_status = 1 : this.shop_status = 0
          }
        })
    },
    setShopStatus() {
      //修改商城开关状态
      let params = { "black": this.shop_status ? 1 : 0 }
      patchApiData('', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getShopStatus()//刷新
        }).catch(err => {
          //关闭/打开开关失败，还原标志
          this.shop_status = this.shop_status ? 0 : 1
        })
    },
    //保存定时开启时间
    submit() {

    },
    //获取数据列表
    getData() {
      this.loading = true
      let params = this.query
      getApiData('team_shop', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openDialog(num, val) {
      //打开 添加/编辑 弹窗
      this.dialogVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
  }
}
</style>